import type {
  CreateUpdateServiceProvidersFormValues,
  PortsFilters,
  PortsFiltersDto,
  PortsList,
  PortsListDto,
  ServiceProvidersFilters,
  ServiceProvidersFiltersDto,
  SinglePort,
  SinglePortDto,
  SingleServiceProvider,
} from './service-providers.dto';

export const mapCreateUpdateServiceProviderValues = (
  values: CreateUpdateServiceProvidersFormValues & { location?: { address?: string | null } },
) => ({
  ...values,
  short_description: values.short_description || null,
  ...(values.location && {
    location: {
      ...values.location,
      address: values.location.address || null,
    },
  }),
  contact_info: {
    ...values.contact_info,
    phone: values.contact_info.phone,
    website: values.contact_info.website || null,
  },
});

export const mapServiceProviderDto = (values: SingleServiceProvider): SingleServiceProvider => ({
  ...values,
  contact_info: {
    ...values.contact_info,
    phone: values.contact_info.phone,
  },
});

export const mapServiceProvidersFilters = ({
  isFavorite,
  type,
  search,
  vesselId,
  currentLat,
  currentLon,
  category,
  howFar,
}: ServiceProvidersFilters): ServiceProvidersFiltersDto => ({
  search,
  is_favorite: isFavorite,
  type,
  vessel_id: vesselId,
  current_lat: currentLat,
  current_lon: currentLon,
  categories: category ? [category] : undefined,
  how_far: howFar,
});

export const mapPortsFilters = ({ currentLat, currentLon }: PortsFilters): PortsFiltersDto => ({
  current_lat: currentLat,
  current_lon: currentLon,
});

export const mapSinglePort = ({
  address,
  id,
  latitude,
  longitude,
  name,
  distance,
}: SinglePortDto): SinglePort => ({
  address,
  id,
  latitude,
  longitude,
  name,
  distance,
});

export const mapPortsList = ({ count, items }: PortsListDto): PortsList => ({
  count,
  items: items.map(mapSinglePort),
});
